<res-generic-grid *ngIf="selectedNode" [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [updateStatusType]="updateStatusType" [headerTemplate]="headerTemplate" [pagerTemplate]="pagerTemplate"
    [pagerVisible]="pagerVisible" [pagerDisabled]="pagerDisabled" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [columnDefs]="columnDefs" [rowSelection]="rowSelection" [requestInfo]="requestInfo" [gridContext]="gridContext"
    [contextMenuOptions]="contextMenuOptions" [cellClickedCallback]="cellClickedCallback"
    [responseArrayCallback]="responseArrayCallback" [cellDoubleClickedCallback]="cellDoubleClickedCallback">
</res-generic-grid>

<ng-template *ngIf="headerTemplateAdded" #headerTemplate>
    <div class='parent-header'>
        <div *ngIf="workflowsHeader && hasAddPermissions">
            <button type="button" *ngIf="(isReefReviewProject && newEntityName === 'export stream')"
                [attr.data-automation-id]="'add-new-reef-review-'+ newEntityName +'-button'" class="secondary-button margin-right-btn" data-bs-toggle="button"
            aria-pressed="false"
                (click)="addNewEntity()">
                <i class="fa fa-plus"></i>New Reef Review Export Stream ...
            </button>
            <button type="button"
                [attr.data-automation-id]="'add-new-'+ newEntityName +'-button'" class="secondary-button margin-button"
                (click)="addNewEntity(newEntityName === 'export stream' ? 'reefReview' : null)">
                <i class="fa fa-plus"></i>{{(newEntityName === 'export stream' && isReefReviewProject) ? 'New Reef ECA ' : 'New '}} {{(newEntityName === 'MediaID') ? (newEntityName) : (newEntityName |
                titlecase)}} ...
            </button>
            <button type="button" *ngIf="hasWorkflowTemplatePermission"
                data-automation-id="load-from-template-button" class="secondary-button"
                (click)="loadFromTemplate()">
                <i class="fa fa-folder-open color-yellow-07"></i>Load from Template ...
            </button>
        </div>
        <div *ngIf="searchHistoryHeader">
            <span class="document-list-selected-items" data-automation-id="search-results-selected-label">Selected:
                <span>{{selectedItems()}}</span></span>
            <div class="search-history-buttons">
                <button type="button" data-automation-id="run-as-combined-search-button"
                    [title]="isRunAsCombinedEnabled() ? '' : 'Please select two or more query-based searches' "
                    (click)="runAsCombinedSearch()" [disabled]="!isRunAsCombinedEnabled()"
                    class="secondary-button margin-button">
                    <i class="fa fa-search-plus"></i>Run As Combined Search ...
                </button>
                <button type="button" data-automation-id="create-export-comparison-report-button"
                    class="secondary-button" (click)="createExportComparisonReport()" *ngIf="hasExportPermissions"
                    [disabled]="!isExportComparisonReportEnabled()">
                    <i class="fa fa-table"></i>Create Export Comparison Report ...
                </button>
            </div>
        </div>
        <div *ngIf="importsHeader">
            <div class="imports-paired-buttons" *ngIf="hasAddPermissions">
                <button type="button" class="secondary-button left-button" (click)="addNewEntity()"
                    data-automation-id="new-data-set-button" [disabled]="projectParsingV1"
                    title="{{projectParsingV1 ? 'You can no longer perform this operation for a Project using Parsing Library Version V1.' : ''}}">
                    <i class="fa fa-plus menu-item-icon" data-automation-id="new-data-set-icon"></i>New Data Set
                    ...</button>
                <button type="button" class="secondary-button right-button" (click)="showImportsMenu($event)"
                    data-automation-id="new-data-set-show-menu-button" [disabled]="projectParsingV1" 
                    title="{{projectParsingV1 ? 'You can no longer perform this operation for a Project using Parsing Library Version V1.' : ''}}">
                    <i class="fa fa-caret-down" data-automation-id="new-data-set-show-menu-icon"></i></button>
            </div>
        </div>
    </div>
</ng-template>

<res-context-menu #importsMenu>
</res-context-menu>